<template>
  <div>
    <div class="warehouse_circle_component">
      <div
        @click="
          $router.push({
            name: 'warehouse-view',
            params: { id: allData.id },
          })
        "
        style="cursor: pointer"
        class="circle_about_section"
      >
        <div style="gap: 80px" class="d-flex">
          <div class="details">
            <h3 class="warehouse_name">
              <slot name="name"></slot>
            </h3>
            <div class="warehouse_detail">
              <p>
                {{ $t("numberOfPlaces") }}
                <span class="detail_number">
                  <slot name="allPlace"></slot>
                </span>
              </p>
              <p>
                {{ $t("busyCount") }}
                <span class="detail_number"><slot name="full"></slot></span>
              </p>
              <p>
                {{ $t("emptyCount") }}
                <span class="detail_number"> <slot name="empty"></slot> </span>
              </p>
            </div>
          </div>
          <div class="percent_circle">
            <v-progress-circular
              class="inside"
              :rotate="-90"
              :size="120"
              :width="6"
              :value="percentage"
              color="#F0A126"
            >
              <span class="align-center">
                <pre class="percentage"> {{ percentage }}%</pre>
                <pre class="partial">{{ partial }}</pre>
              </span>
            </v-progress-circular>
          </div>
        </div>
        <div>
          <p style="color: #7a889b" class="text-center my-5">
            {{ $t("outgoingGoods") }}
          </p>
          <p
            style="color: #48545d; font-size: 28px"
            class="text-center font-weight-bold"
          >
            {{ allData.outgoProductCount }}
          </p>
        </div>
        <div>
          <p style="color: #7a889b" class="text-center my-5">
            {{ $t("incomingGoods") }}
          </p>
          <p
            style="color: #48545d; font-size: 28px"
            class="text-center font-weight-bold"
          >
            {{ allData.incomeProductCount }}
          </p>
        </div>

        <div>
          <p style="color: #7a889b" class="text-center my-5">
            {{ $t("remainingCurrently") }}
          </p>
          <p
            style="color: #48545d; font-size: 28px"
            class="text-center font-weight-bold"
          >
            {{ allData.currentProductCount }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "chart-donut-new",
  data() {
    return {
      form: {
        fromDate: "",
        toDate: "",
      },
    };
  },
  methods: {
    handleFilterEmit() {
      this.$emit("filter", this.form);
    },
  },
  props: {
    percentage: {
      type: Number,
    },
    partial: {
      type: String,
    },
    allData: {
      type: Object,
    },
  },
};
</script>

<style scoped lang="scss">
.warehouse_circle_component {
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  width: 100%;
  border-radius: 6px;
  border: 1px solid #dfe2e9;

  .circle_about_section {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    padding-bottom: 10px;
    padding: 20px;
    border-bottom: 1px solid #dfe2e9;

    .details {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      p {
        font-size: 14px;
        color: #7a889b;
        font-weight: 400;

        span {
          font-weight: 700;
          color: #48545d;
        }
      }

      .warehouse_name {
        font-size: 16px;
        color: #48545d;
        font-weight: 700;
      }

      .warehouse_detail {
        display: flex;
        flex-direction: column;
        p {
          margin-bottom: 0 !important;
        }
      }
    }
  }

  .circle_actions_section {
    padding: 20px;
    display: flex;
    gap: 10px;
    justify-content: flex-end;
  }

  .v-progress-circular span {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #303d4d;

    .percentage {
      font-size: 24px;
    }

    .partial {
      font-size: 12px;
    }
  }
}
</style>
